import React from 'react';
import { Toast, ToastButton, createToast } from '../../../components/core';

export const showStatisticsDelayToast = () =>
  createToast(
    <Toast type="brand">
      {
        'Review statistics are taking longer than usual to load. Please reload the page to try again.'
      }
      <ToastButton to={window.location.href}>Reload</ToastButton>
    </Toast>
  );
